var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClipboard2 = function SvgClipboard2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.875 17.594h8.313A.61.61 0 0 0 11.78 17v-2.375h1.781V17a2.37 2.37 0 0 1-2.374 2.375H2.874A2.345 2.345 0 0 1 .5 17V8.688a2.37 2.37 0 0 1 2.375-2.376H5.25v1.782H2.875a.61.61 0 0 0-.594.594V17c0 .334.26.594.594.594M6.438 2.75A2.37 2.37 0 0 1 8.813.375h8.312A2.39 2.39 0 0 1 19.5 2.75v8.313a2.37 2.37 0 0 1-2.375 2.374H8.813a2.345 2.345 0 0 1-2.376-2.374zm2.375 8.906h8.312a.61.61 0 0 0 .594-.594V2.75c0-.297-.297-.594-.594-.594H8.813a.61.61 0 0 0-.594.594v8.313c0 .333.26.593.594.593"
  })));
};
export default SvgClipboard2;